import { mapIntegrals } from './mapIntegrals';
import { updateIntegralsRelativeValues } from './updateIntegralsRelativeValues';
export function updateIntegrals(spectrum) {
    spectrum.integrals.values = mapIntegrals(spectrum.integrals.values, spectrum, 'current');
    updateIntegralsRelativeValues(spectrum, true);
}
//# sourceMappingURL=updateIntegrals.js.map